export default __webpack_public_path__ + "static/bodySectionBg-6dc8667e2d0df358176d59c155dd4ef7.png";